import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { useUnit } from 'hooks/units/index';
import useWindowSize from 'hooks/useWindowSize';
import useRefresh from 'hooks/useRefresh';
import { completeUnitAsync } from 'store/units/index';

import { COURSE_STATUS, STATUS_SCORM, UNIT_STATUS } from 'constants/constants';
import getScript from 'helpers/getScript';

import ButtonComplete from '../Content/Complete/ButtonComplete';
import ButtonCompleted from '../Content/Complete/ButtonCompleted';
import { getSelectedCentre } from 'store/master';
import ButtonNotPassed from './ButtonNotPassed';

const ContentScorm = (props) => {
  const unitSelected = useUnit();
  const dispatch = useDispatch();
  const selectedCentre = useSelector(getSelectedCentre);
  const { query } = useRouter();
  const [width, height] = useWindowSize();
  const { superFastRefresh } = useRefresh();
  const [status, setStatus] = useState('incomplete');

  //DisableConditon
  let isDisabled = unitSelected?.status == COURSE_STATUS.INACTIVE;

  const renderButtonComplete = () => {
    if (unitSelected.status === UNIT_STATUS.FAILED) {
      return <ButtonNotPassed />;
    }

    if (unitSelected.status === UNIT_STATUS.COMPLETED) {
      return <ButtonCompleted />;
    }

    if (status === STATUS_SCORM.incomplete) {
      return (
        <Button.Ripple disabled={isDisabled} className="round">
          Incomplete
        </Button.Ripple>
      );
    }

    return <ButtonComplete />;
  };

  const resizer = () => {
    if (!unitSelected) return;

    const contentElm = document.getElementById('scorm-content-frame');
    const iframe = document.getElementById('sc_content');
    const { clientWidth } = contentElm;

    const { clientHeight } = document.body;

    iframe.height = clientHeight;
    iframe.width = clientWidth;
  };

  useEffect(() => {
    resizer();
  }, [width, height, unitSelected]);

  useEffect(() => {
    getScript('/scormV2.js', function () {
      document
        .getElementById('sc_content')
        ?.setAttribute('src', unitSelected?.file?.pathView);
      // document.getElementById('sc_content')?.setAttribute('src', '/scorm/res/index.html');
    });
  }, []);

  useEffect(() => {
    function receiveMessage(e) {
      if (
        !unitSelected?.status &&
        e?.data?.sendValues &&
        e?.data?.sendValues?.lesson_status !== STATUS_SCORM.incomplete
      ) {
        const body = {
          data: e?.data?.sendValues,
          status:
            e?.data?.sendValues?.lesson_status === STATUS_SCORM.failed
              ? UNIT_STATUS.FAILED
              : UNIT_STATUS.COMPLETED,
        };
        let param = {};
        if (selectedCentre?._id) {
          param.centreId = selectedCentre?._id;
        }
        if (
          selectedCentre?.reviewContent ||
          selectedCentre?.reviewContent === undefined
        ) {
          param.reviewContent = true;
        }

        dispatch(completeUnitAsync(body, unitSelected._id, query?.slug, param));
      }
    }

    window.addEventListener('message', receiveMessage);
    return () => window.removeEventListener('message', receiveMessage);
  }, [query, unitSelected]);

  useEffect(() => {
    if (window?.API?.LMSGetLastError() === '301') {
      setStatus(STATUS_SCORM.completed);
    }
  }, [superFastRefresh]);

  return (
    <div id="scorm-content-frame">
      <iframe
        className={`tl-scorm-frame ${
          props.fullScreens ? 'full-screen-mode' : ''
        }`}
        id="sc_content"
        style={{
          width: '100%',
          height: 'calc(100vh - 70px)',
        }}
        allowFullScreen
      />
      <div className="text-center">{renderButtonComplete()}</div>
    </div>
  );
};

export default ContentScorm;
